import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { FaGlobeAmericas, FaLaptop, FaHome, FaSearch, FaLink } from "react-icons/fa";
import { FaComputer } from "react-icons/fa6";
import { GrAndroid } from "react-icons/gr";
import { ImFilePicture } from "react-icons/im";
import { TbSchool } from "react-icons/tb";
import { IoMdPaperPlane } from "react-icons/io";

import Navbar from '../components/Navbar';
import Slider from '../components/Slider';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

import Image1 from "../images/slider/1.jpg";
import Image2 from "../images/slider/2.jpg";

const IMAGES = [Image1, Image2];

const HomePage = () => {
    const home = useRef(null);
    const service = useRef(null);
    const about = useRef(null);
    const portfolio = useRef(null);
    const contact = useRef(null);
    const location = useLocation();

    // Check for navigation to DIV and navigate
    useEffect(() => {
        if (location.hash === '#home' && home.current) {
            home.current.scrollIntoView({ behavior: 'smooth' });
        } else if (location.hash === '#service' && service.current) {
            service.current.scrollIntoView({ behavior: 'smooth' });
        } else if (location.hash === '#portfolio' && portfolio.current) {
            portfolio.current.scrollIntoView({ behavior: 'smooth' });
        } else if (location.hash === '#about' && about.current) {
            about.current.scrollIntoView({ behavior: 'smooth' });
        } else if (location.hash === '#contact' && contact.current) {
            contact.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location.hash]);

    return (
        <div>
            {/* Navigation */}
            <Navbar />

            {/* start home */}
            <section id="home" ref={home}>
                <div className="overlay">
                    <Slider imageUrls={IMAGES} />
                </div>
            </section>
            {/* end home  */}

            {/* start service  */}
            <section id="service" ref={service}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center wow bounceIn">
                            <h2 className="text-uppercase">Services</h2>
                            <hr />
                            <h4>At <span style={{ color: "#55ACEE", fontWeight: "bold" }}>
                                Brainytech Networks Resources Ltd.</span>, we specialize in Software, Networking, Online Security, Computer Maintenance, Graphics Design, Web, Mobile and Desktop App Development. We also carryout sales and leasing of real estate.
                            </h4>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <FaLaptop size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">Web App Development</h3>
                                    <p>We produce high-end websites and softwares for clients across various business and social endeavours.</p>
                                </div>.
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <GrAndroid size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">Mobile & Desktop App</h3>
                                    <p>We produce Native and Cross platform applications to meet modern mobile and desktop applications requirements. User satisfaction is always our watch word.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <TbSchool size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">Online IT Training</h3>
                                    <p>We tutor aspiring developers to become fully qualified Frontend, Backend, Fullstack and Cybersecurity Professionals, etc. <span><Link to="academy">...Learn more</Link></span></p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <FaHome size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">Real Estate Services</h3>
                                    <p>We sell and lease real estate, according to your needs. Owing to our years of practice, we provide reliable services at best prices. <a href="realestate">Read more...</a>  </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <IoMdPaperPlane size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">Travel Agency</h3>
                                    <p>We offer seemless travel solutions to make your dreams a reality. Whether it be schooling abroad, work travels or vacation, we got you covered.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <FaComputer size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">General Supplies</h3>
                                    <p>We supply computers, accessories, system consummables, office equipment, hospital equipment and household goods.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <FaGlobeAmericas size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">Networking &amp; Office Automation</h3>
                                    <p>We set up offices with high level information technology, Networking and Computer equipment. We also carry out computer maintenance and supplies. </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="media">
                                <div className="media-object media-left wow fadeIn" data-wow-delay="0.6s">
                                    <ImFilePicture size={60} color='#55ACEE' />
                                </div>
                                <div className="media-body">
                                    <h3 className="media-heading">SEO, Marketing/Branding & Graphics Design</h3>
                                    <p>We optimise your website and brand your business to give you an unprecedented online presence, which serves to boost patronage of your services/business. We also design high-end graphics for online and offline consumption.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            {/* end service  */}

            {/* start divider  */}
            <div className="divider">
                <div className="overlay">
                    <div className="container">
                        <div className="row">
                            <div className="divider-des">
                                <h3 className="text-uppercase">We deliver best results always</h3>
                                <p>A trial will keep you yearning for more of our services</p>
                                <a className="btn btn-default text-uppercase" href="#contact" style={{ color: "#fff" }}> Contact Us</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end divider  */}

            {/* start about  */}
            <section id="about" ref={about}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 wow bounceIn">
                            <h2 className="text-uppercase">About</h2>
                            <hr />
                            <h4>a little about our company...</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-6 wow fadeInLeft brainytech-about-left" data-wow-delay="0.3s">
                            <h3 className="about-title" style={{ color: "#55acee" }}><b>Company History</b></h3>
                            <p>Brainytech Networks Resources Ltd. was founded by Mr. Daniel Isah, a Web and Software Developer, Graphics Designer, Cybersecuritysecurity Professional, Digital Marketer and Data Analyst. He has been in the industry for over ten years and is equipped with professional and hands-on experience to deliver quality always. He is also vast in Real Estate but specializes in sales and leasing of high quality commercial and residential real estate.</p>
                            <p>In his pursuit of excellence and customer satisfaction, he saw the need to involve other capable hands in service delivery and has partnered with associates who specialize in various ICT fields and Real Estate. Below are a few of his associates.</p>
                        </div>
                        <div className="col-md-6 col-sm-6 wow fadeInRight" data-wow-delay="0.3s">
                            <span className="text-uppercase">QUALITY DELIVERY & CUSTOMER SATISFACTION 100%</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{ width: "100%" }}></div>
                            </div>
                            <span className="text-uppercase">DESIGN AND CONTENT DEVELOPMENT 95%</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style={{ width: "95%" }}></div>
                            </div>
                            <span className="text-uppercase">GLOBAL BEST PRACTICES AND SECURITY 99%</span>
                            <div className="progress">
                                <div className="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100" style={{ width: "99%" }}></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-sm-4 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="about-wrapper">
                                <img src="images/team-img-1.jpg" className="img-responsive" alt="about img" />
                                <h3>Daniel Isah</h3>
                                <h5>MD/Chief Technology Officer</h5>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="about-wrapper">
                                <img src="images/team-img-2.png" className="img-responsive" alt="about img" />
                                <h3>Simon Onazi</h3>
                                <h5>Software Engineer</h5>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="about-wrapper">
                                <img src="images/team-img-3.png" className="img-responsive" alt="about img" />
                                <h3>Charles Mmuo</h3>
                                <h5>Creative Manager and Content Developer </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* end about */}

            {/* start portfolio  */}
            <section id="portfolio" ref={portfolio}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="wow bounceIn">
                                <h2 className="wow bounceIn text-uppercase">Portfolio</h2>
                                <hr />
                                <h4>our lastest projects in the past 6 months</h4>
                            </div>
                            <div className="iso-section wow fadeIn" data-wow-delay="0.6s">

                                <ul className="filter-wrapper clearfix">
                                    <li><a href="#selection" data-filter="*" className="selected opc-main-bg">All</a></li>
                                    <li><a href="#selection" className="opc-main-bg" data-filter=".graphic">Web & Graphic Design</a></li>
                                    <li><a href="#selection" className="opc-main-bg" data-filter=".networking">Networking & Security</a></li>
                                    <li><a href="#selection" className="opc-main-bg" data-filter=".branding">Branding & Social Media</a></li>
                                    <li><a href="#selection" className="opc-main-bg" data-filter=".real_estate">Real Estate</a></li>
                                </ul>

                                <div id='selection' className="iso-box-section">
                                    <div className="iso-box-wrapper col4-iso-box">

                                        <div className="iso-box graphic photoshop wallpaper col-md-4 col-sm-6 col-xs-12">
                                            <div className="portfolio-thumb">
                                                <img src="images/portfolio-img-1.jpg" className="fluid-img" alt="portfolio img" />
                                                <div className="portfolio-overlay">
                                                    <div className="portfolio-description">
                                                        <div className='icon-span-container'>
                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaSearch size={15} />
                                                                </span>
                                                            </a>

                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaLink size={15} />
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <h4>WEB AND GRAPHICS DESIGN</h4>
                                                        <p>We have developed a number of professional and unique web and mobile applications for our clients and look forward to serving you. We also produce high end graphics for commercial and domestic use.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="iso-box graphic col-md-4 col-sm-6 col-xs-12">
                                            <div className="portfolio-thumb">
                                                <img src="images/portfolio-img-2.jpg" className="fluid-img" alt="portfolio img" />
                                                <div className="portfolio-overlay">
                                                    <div className="portfolio-description">
                                                        <div className='icon-span-container'>
                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaSearch size={15} />
                                                                </span>
                                                            </a>

                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaLink size={15} />
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <h4>ANIMATION</h4>
                                                        <p>We produce high quality 3D Animations for your personal and business advertisement needs. We give you the edge over your competitors by making your goods and/or services more attractive and captivating through animated videos and images.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="iso-box wallpaper real_estate col-md-4 col-sm-6 col-xs-12">
                                            <div className="portfolio-thumb">
                                                <img src="images/portfolio-img-3.jpg" className="fluid-img" alt="portfolio img" />
                                                <div className="portfolio-overlay">
                                                    <div className="portfolio-description">
                                                        <div className='icon-span-container'>
                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaSearch size={15} />
                                                                </span>
                                                            </a>

                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaLink size={15} />
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <h4>BRANDING</h4>
                                                        <p>We offer branding services and have a number of satisfied customers. We give your business or brand a professional appearance on and off social media; thus, boosting your customer base.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="iso-box real_estate col-md-4 col-sm-6 col-xs-12">
                                            <div className="portfolio-thumb">
                                                <img src="images/portfolio-img-4.jpg" className="fluid-img" alt="portfolio img" />
                                                <div className="portfolio-overlay">
                                                    <div className="portfolio-description">
                                                        <div className='icon-span-container'>
                                                            <a href="/realestate">
                                                                <span className='icon-span'>
                                                                    <FaSearch size={15} />
                                                                </span>
                                                            </a>

                                                            <a href="/realestate">
                                                                <span className='icon-span'>
                                                                    <FaLink size={15} />
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <h4>REAL ESTATE</h4>
                                                        <p>We carry out sales and leasing services in the real estate sector. We major in high quality real estate and have sold and leased a number of properties.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="iso-box networking col-md-4 col-sm-6 col-xs-12">
                                            <div className="portfolio-thumb">
                                                <img src="images/portfolio-img-5.jpg" className="fluid-img" alt="portfolio img" />
                                                <div className="portfolio-overlay">
                                                    <div className="portfolio-description">
                                                        <div className='icon-span-container'>
                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaSearch size={15} />
                                                                </span>
                                                            </a>

                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaLink size={15} />
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <h4>NETWORKING AND SECURITY</h4>
                                                        <p>We  set up and automate offices according to your ICT needs. We offer advanced security and networking services to stimulate smooth running of your business.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="iso-box graphic branding col-md-4 col-sm-6 col-xs-12">
                                            <div className="portfolio-thumb">
                                                <img src="images/portfolio-img-6.jpg" className="fluid-img" alt="portfolio img" />
                                                <div className="portfolio-overlay">
                                                    <div className="portfolio-description">
                                                        <div className='icon-span-container'>
                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaSearch size={15} />
                                                                </span>
                                                            </a>

                                                            <a href="#">
                                                                <span className='icon-span'>
                                                                    <FaLink size={15} />
                                                                </span>
                                                            </a>
                                                        </div>
                                                        <h4>ONLINE MARKETING</h4>
                                                        <p>We offer online marketing services for your intellectual and physical products. Thus, we market and promote music tracks and books for artists and book writers respectively. Simply put, if you can think or produce it, we go beyond just creating a site for you, we could also handle the entire marketing process.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* end portfolio */}

            {/* contact  */}
            <Contact ref={contact} />

            {/* Footer */}
            <Footer />

        </div >
    )
}

export default HomePage;